import { Component, inject, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModalService } from '../../../services/auth-modal.service';
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { ModalRegisterComponent } from '../modal-register/modal-register.component';
import { ModalVerificationComponent } from '../modal-verification/modal-verification.component';
import { ModalPaymentMethodComponent } from '../modal-payment-method/modal-payment-method.component';
import { PurchaseStateService } from '../../../services/purchase-state.service';
import { ModalTicketTransferComponent } from '../modal-ticket-transfer/modal-ticket-transfer.component';

@Component({
  selector: 'app-auth-modals-host',
  imports: [CommonModule, ModalLoginComponent, ModalRegisterComponent, ModalVerificationComponent, ModalPaymentMethodComponent, ModalTicketTransferComponent],
  templateUrl: './auth-modals-host.component.html',
  styleUrl: './auth-modals-host.component.scss',
})
export class AuthModalsHostComponent {
  readonly modalService = inject(AuthModalService);
  readonly purchaseState = inject(PurchaseStateService);

  @HostListener('document:keydown.escape')
  onEscKey(): void {
    this.modalService.close();
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.modalService.close();
    }
  }
}
